import React, { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../Utils/responsive';
import LoginWeb from './web';
import LoginMob from './mob';

const Login = ({ emailOnly = false }: { emailOnly?: boolean }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <LoginMob emailOnly={emailOnly} /> : <LoginWeb emailOnly={emailOnly} />;
};

export default Login;
